import { assert } from 'assert-ts';
import { useNavigate, useParams } from 'react-router';
import { useSuspenseTOTPAuthenticatorsQuery } from '#api/totp-authenticators.queries.ts';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { DeleteTOTPDialog } from './DeleteTOTPDialog.tsx';
import { DeleteTOTPError } from './DeleteTOTPError.tsx';

/**
 * This component decides whether the totp can be deleted, and shows either an error modal
 * or a host deletion modal.
 */
export function DeleteTOTPModal() {
  const { totpId } = useParams() as { totpId: string };
  const { user } = useAuth();
  const {
    data: { data: TOTPAuthenticators },
  } = useSuspenseTOTPAuthenticatorsQuery();
  const navigate = useNavigate();

  function returnToUserSettings() {
    void navigate('..', { replace: true });
  }

  assert(TOTPAuthenticators.length > 0, 'expected at least one totp to exist');

  // The whoami flag tells us whether the user has a WebAuthn credential
  // without making an additional API call.
  const hasWebAuthnFallback = user?.type === 'user' && user.hasWebAuthnAuthenticator;
  const isLastAuthenticator = TOTPAuthenticators.length < 2 && !hasWebAuthnFallback;

  return isLastAuthenticator ?
      <DeleteTOTPError onClose={returnToUserSettings} />
    : <DeleteTOTPDialog id={totpId} onClose={returnToUserSettings} />;
}
